/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_1_AInputs */

const en_mk_pricing_faq_1_a = /** @type {(inputs: Mk_Pricing_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It's simple and easy to budget. Agents aren't billed as paid seats — AI quota is pooled per workspace, not per person.`)
};

const id_mk_pricing_faq_1_a = /** @type {(inputs: Mk_Pricing_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supaya jelas dan mudah dihitung. Agen tidak dihitung sebagai kursi berbayar — kuota AI dibagi bersama satu workspace, bukan per orang.`)
};

/**
* | output |
* | --- |
* | "It's simple and easy to budget. Agents aren't billed as paid seats — AI quota is pooled per workspace, not per person." |
*
* @param {Mk_Pricing_Faq_1_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_1_a = /** @type {((inputs?: Mk_Pricing_Faq_1_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_1_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_1_a(inputs)
	return en_mk_pricing_faq_1_a(inputs)
});